export const IP_ADDRESS_COOKIE_NAME = 'ipAddress';
